import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {
    CustomerBillingAccountTransactionDto
} from "../../../../model/dto/entity/customer-billing-account-transaction.dto";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";

@Component({
    selector: 'bm-customer-billing-account-transaction-object-component-base',
    template: '',
    standalone: false
})
export class BmCustomerBillingAccountTransactionObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    dto: CustomerBillingAccountTransactionDto;
    @Output() onCustomerBillingAccountSelect: EventEmitter<number> = new EventEmitter();

    constructor(protected route: ActivatedRoute) {
        super(route);
    }

    ngOnInit() {
        super.ngOnInit();

        this.initialized = true;
    }

    handleCustomerBillingAccountSelect(id: number) {
        this.onCustomerBillingAccountSelect.emit(id);
    }



}
